import Vue from 'vue'
import Router from 'vue-router'
import Login from './components/Login'
import CDR from './components/CDR'
import ForgotPassword from './components/Forgot_Password'
import Dashboard from './components/Dashboard'
import DashboardInfo from './components/dashboardInfo/Dashboard_Info'
import DashboardInfo2 from './components/dashboardInfo2/Dashboard_Info.new2'

import NoticeTunaiPro from './components/dashboard/notice/tunaipro/Notice_TunaiPro'

import Member from './components/dashboard/mySalon/member/MenuMember'
import Member2 from './components/dashboard/mySalon/member2/MenuMember'
import Member3 from './components/dashboard/mySalon/member3/MenuMember'
import Member4 from './components/dashboard/mySalon/member4/MenuMember'
import User from './components/dashboard/mySalon/user/MenuUser'
import BrandGeneral from './components/dashboard/mySalon/branding/Brand_General'
import BrandChecklist from './components/dashboard/mySalon/branding/Brand_Checklist'
import BrandConfiguration from './components/dashboard/mySalon/branding/Brand_Configuration'
import BrandPayment from './components/dashboard/mySalon/branding/Brand_Payment'
import Setup from './components/dashboard/mySalon/setup/MenuSetup'
import ChangePassword from './components/dashboard/mySalon/Change_Password'
import ChangeLoyaltyPassword from './components/dashboard/mySalon/Change_Loyalty_Password'
import Tukang from './components/dashboard/mySalon/tukang/MenuTukang'
import Appointment from './components/dashboard/mySalon/appointment/MenuAppointment'
import Appointment2 from './components/dashboard/mySalon/appointment2/MenuAppointment'
import Appointment3 from './components/dashboard/mySalon/appointment3/MenuAppointment'
import SalonStaff from './components/dashboard/mySalon/staff/MenuStaff'
import Message from './components/dashboard/mySalon/message/Menu_Message'
import Broadcast from './components/dashboard/mySalon/broadcast/Broadcast'
import Voucher from './components/dashboard/mySalon/voucher/MenuVoucher'
import RewardQR from './components/dashboard/mySalon/rewardqr/MenuRewardQR'
import ConsentForm from './components/dashboard/mySalon/consentForm/ConsentForm'
import ConsentFormMember from './components/dashboard/mySalon/consentFormMember/ConsentForm'

import ReportCommission from './components/dashboard/salonReport/commission/MenuReportCommission'
import ReportOrder from './components/dashboard/salonReport/order/MenuReportOrder'
import ReportOrder2 from './components/dashboard/salonReport/order2/MenuReportOrder'
import ReportDelivery from './components/dashboard/salonReport/delivery/MenuReportDelivery'
import ReportExpenses from './components/dashboard/salonReport/expenses/MenuReportExpenses'
import ReportPayment from './components/dashboard/salonReport/payment/MenuReportPayment'
import ReportPayment2 from './components/dashboard/salonReport/payment2/MenuReportPayment'
import ReportPayment3 from './components/dashboard/salonReport/payment3/MenuReportPayment'
import ReportSales20221204 from './components/dashboard/salonReport/sales/MenuReportSales'
import ReportSales from './components/dashboard/salonReport/sales2/MenuReportSales'
import ReportCredits from './components/dashboard/salonReport/credit/MenuReportCredit'
import ReportOutstandings from './components/dashboard/salonReport/outstandings/MenuReportOutstandings'
import ReportPoints from './components/dashboard/salonReport/points/MenuReportPoints'
import ReportVoucher from './components/dashboard/salonReport/voucher/MenuReportVoucher'
import Stock from './components/dashboard/salonReport/stock/Stock'
import Stock2 from './components/dashboard/salonReport/stock2/Stock'
import Stock3 from './components/dashboard/salonReport/stock3/Stock'
import ReportAttendance from './components/dashboard/salonReport/attendance/MenuReportAttendance'
import ReportVisit from './components/dashboard/salonReport/visit/MenuReportVisit'
import ReportPoke from './components/dashboard/salonReport/poke/MenuReportPoke'
import ReportReward from './components/dashboard/salonReport/reward/MenuReportReward'
import TopSelling from './components/dashboard/salonReport/topSelling/MenuReportTopSelling'
import ReportRoster from './components/dashboard/salonReport/roster/MenuReportRoster'
import ReportRoster2 from './components/dashboard/salonReport/roster2/MenuReportRoster'
import ReportRoom from './components/dashboard/salonReport/room/MenuReportRoom'

import MenuReward from './components/dashboard/salonMenu/reward/MenuReward'
import MenuService from './components/dashboard/salonMenu/service/MenuService'
import MenuService2 from './components/dashboard/salonMenu/service2/MenuService'
import MenuService3 from './components/dashboard/salonMenu/service3/Menu'
import MenuProduct from './components/dashboard/salonMenu/product/MenuProduct'
import MenuProduct2 from './components/dashboard/salonMenu/product2/MenuProduct'
import MenuProduct3 from './components/dashboard/salonMenu/product3/Menu'
import MenuPackage from './components/dashboard/salonMenu/package/MenuPackage'
import MenuPackage3 from './components/dashboard/salonMenu/package3/Menu'
import MenuDiscount from './components/dashboard/salonMenu/discount/MenuDiscount'
import MenuDiscount3 from './components/dashboard/salonMenu/discount3/Menu'
import MenuTreatment from './components/dashboard/salonMenu/treatment/MenuTreatment'
import MenuConfiguration from './components/dashboard/salonMenu/MenuConfiguration'

import Outlet from './components/dashboard/outletSetting/Outlet'
import Washer from './components/dashboard/outletSetting/Washer'
import SocialMedia from './components/dashboard/outletSetting/SocialMedia'
import OutletSetup from './components/dashboard/outletSetting/OutletSetup'
import Receipt from './components/dashboard/outletSetting/receipt/Receipt'
import Info from './components/dashboard/outletSetting/info/Info'
import Landing from './components/dashboard/outletSetting/landing/Landing'
import Booking from './components/dashboard/outletSetting/booking/Booking'
import BookingBlockList from './components/dashboard/outletSetting/booking/Booking_BlockList'
import Staff from './components/dashboard/outletSetting/staff2/Staff'
import Staff3 from './components/dashboard/outletSetting/staff3/Staff'
import Roster from './components/dashboard/outletSetting/roster/Staff_Roster'
import SecuritySetting from './components/dashboard/outletSetting/security/SecuritySetting'

import CustomizeAppToken from './components/dashboard/outletSetting/CustomizeAppToken'

import StaffScheme from './components/dashboard/roster/staffScheme/Main'
import LeaveRequest from './components/dashboard/roster/leaveRequest/Main'
import OffDay from './components/dashboard/roster/offDay/Main'

import WenawaveSales from './components/dashboard/commission/Wenawave/Sales/MenuReportSales'
import WenawaveCommission from './components/dashboard/commission/Wenawave/Commission/MenuReportCommission'
import AuraQ7Sales from './components/dashboard/commission/AuraQ7/Sales/MenuReportSales'
import AuraQ7Commission from './components/dashboard/commission/AuraQ7/Commission/MenuReportCommission'
import AriaWellnessSales from './components/dashboard/commission/AriaWellness/Sales/MenuReportSales'
import AriaWellnessCommission from './components/dashboard/commission/AriaWellness/Commission/MenuReportCommission'
import LawaWaxSales from './components/dashboard/commission/LawaWax/Sales/MenuReportSales'
import LawaWaxCommission from './components/dashboard/commission/LawaWax/Commission/MenuReportCommission'
import BiancoByMeiNgSales from './components/dashboard/commission/BiancoByMeiNg/Sales/MenuReportSales'
import BiancoByMeiNgCommission from './components/dashboard/commission/BiancoByMeiNg/Commission/MenuReportCommission'
import RegalBeauteSales from './components/dashboard/commission/RegalBeaute/Sales/MenuReportSales'
import RegalBeauteCommission from './components/dashboard/commission/RegalBeaute/Commission/MenuReportCommission'
import ZenthSales from './components/dashboard/commission/Zenth/Sales/MenuReportSales'
import ZenthCommission from './components/dashboard/commission/Zenth/Commission/MenuReportCommission'
import EstrellaSales from './components/dashboard/commission/Estrella/Sales/MenuReportSales'
import EstrellaCommission from './components/dashboard/commission/Estrella/Commission/MenuReportCommission'
import NimrocSales from './components/dashboard/commission/Nimroc/Sales/MenuReportSales'
import NimrocCommission from './components/dashboard/commission/Nimroc/Commission/MenuReportCommission'
import SevenHairStudioSales from './components/dashboard/commission/SevenHairStudio/Sales/MenuReportSales'
import SevenHairStudioCommission from './components/dashboard/commission/SevenHairStudio/Commission/MenuReportCommission'
import TheOneOnlyFitnessSales from './components/dashboard/commission/TheOneOnlyFitness/Sales/MenuReportSales'
import TheOneOnlyFitnessCommission from './components/dashboard/commission/TheOneOnlyFitness/Commission/MenuReportCommission'
import OriyaSales from './components/dashboard/commission/Oriya/Sales/MenuReportSales'
import OriyaCommission from './components/dashboard/commission/Oriya/Commission/MenuReportCommission'
import DAsiaWellnessSales from './components/dashboard/commission/DAsiaWellness/Sales/MenuReportSales'
import DAsiaWellnessCommission from './components/dashboard/commission/DAsiaWellness/Commission/MenuReportCommission'
import JNSkinSales from './components/dashboard/commission/JNSkin/Sales/MenuReportSales'
import JNSkinCommission from './components/dashboard/commission/JNSkin/Commission/MenuReportCommission'
import EnchantedSiblingSales from './components/dashboard/commission/EnchantedSibling/Sales/MenuReportSales'
import EnchantedSiblingCommission from './components/dashboard/commission/EnchantedSibling/Commission/MenuReportCommission'
import VIISkinSales from './components/dashboard/commission/VIISkin/Sales/MenuReportSales'
import VIISkinCommission from './components/dashboard/commission/VIISkin/Commission/MenuReportCommission'
import NailMiStudioSales from './components/dashboard/commission/NailMiStudio/Sales/MenuReportSales'
import NailMiStudioCommission from './components/dashboard/commission/NailMiStudio/Commission/MenuReportCommission'
import CombAndCutSales from './components/dashboard/commission/CombAndCut/Sales/MenuReportSales'
import CombAndCutCommission from './components/dashboard/commission/CombAndCut/Commission/MenuReportCommission'
import TheNailEdgeSales from './components/dashboard/commission/TheNailEdge/Sales/MenuReportSales'
import TheNailEdgeCommission from './components/dashboard/commission/TheNailEdge/Commission/MenuReportCommission'
import OrientalSpaSales from './components/dashboard/commission/OrientalSpa/Sales/MenuReportSales'
import OrientalSpaCommission from './components/dashboard/commission/OrientalSpa/Commission/MenuReportCommission'
import UnifitSales from './components/dashboard/commission/Unifit/Sales/MenuReportSales'
import UnifitCommission from './components/dashboard/commission/Unifit/Commission/MenuReportCommission'
import PhiloHeadspaSales from './components/dashboard/commission/PhiloHeadspa/Sales/MenuReportSales'
import PhiloHeadspaCommission from './components/dashboard/commission/PhiloHeadspa/Commission/MenuReportCommission'
import OrganicWaySales from './components/dashboard/commission/OrganicWay/Sales/MenuReportSales'
import OrganicWayCommission from './components/dashboard/commission/OrganicWay/Commission/MenuReportCommission'
import PhiloHairStudioSales from './components/dashboard/commission/PhiloHairStudio/Sales/MenuReportSales'
import PhiloHairStudioCommission from './components/dashboard/commission/PhiloHairStudio/Commission/MenuReportCommission'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '',
      redirect: { name: 'login' }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/forgotPassword',
      name: 'forgotPassword',
      component: ForgotPassword
    },
    {
      path: '/dashboard/',
      name: 'dashboard',
      component: Dashboard,
      children:[
        {
          path: 'salon_report_cdr',
          name: 'salon_report_cdr',
          component: CDR
        },
        {
          path: 'salon_roster',
          name: 'salon_roster',
          component: Roster
        },
        {
          path: 'salon_report_roster',
          name: 'salon_report_roster',
          component: ReportRoster
        },
        {
          path: 'salon_report_roster2',
          name: 'salon_report_roster2',
          component: window.location.href.includes('devbusiness') ? ReportRoster2 : NoticeTunaiPro
        },
        {
          path: 'salon_report_room',
          name: 'salon_report_room',
          component: window.location.href.includes('devbusiness') ? ReportRoom : NoticeTunaiPro
        },
        {
          path: 'dashboard_info',
          name: 'dashboard_info',
          component: DashboardInfo
        },
        {
          path: 'dashboard_info2',
          name: 'dashboard_info2',
          component: DashboardInfo2
        },
        {
          path: 'my_salon_member',
          name: 'member',
          component: Member
        },
        {
          path: 'my_salon_member2',
          name: 'member2',
          component: Member2
        },
        {
          path: 'my_salon_member3',
          name: 'member3',
          component: Member3
        },
        {
          path: 'my_salon_member4',
          name: 'member4',
          component: Member4
        },
        {
          path: 'my_salon_voucher',
          name: 'voucher',
          component: Voucher
        },
        {
          path: 'my_salon_appointment',
          component: Appointment
        },
        {
          path: 'my_salon_appointment2',
          component: Appointment2
        },
        {
          path: 'my_salon_appointment3',
          component: Appointment3
        },
        {
          path: 'my_salon_rewardqr',
          component: RewardQR
        },
        {
          path: 'my_salon_consentform',
          component: ConsentForm
        },
        {
          path: 'my_salon_consentform_member',
          component: ConsentFormMember
        },
        {
          path: 'my_salon_staffs',
          component: SalonStaff
        },
        {
          path: 'my_salon_message',
          component: Message
        },
        {
          path: 'my_salon_user',
          name: 'user',
          component: User
        },
        {
          path: 'change_password',
          name: 'changePassword',
          component: ChangePassword
        },
        {
          path: 'change_loyalty_password',
          name: 'change_loyalty_password',
          component: ChangeLoyaltyPassword
        },
        {
          path: 'my_salon_branding/brand_setup_general',
          component: BrandGeneral
        },
        {
          path: 'my_salon_branding/brand_setup_checklist',
          component: BrandChecklist
        },
        {
          path: 'my_salon_branding/brand_setup_configuration',
          component: BrandConfiguration
        },
        {
          path: 'my_salon_branding/brand_setup_payment',
          component: window.location.href.includes('devbusiness') ? BrandPayment : NoticeTunaiPro
        },
        {
          path: 'my_salon_tukang',
          component: Tukang
        },
        {
          path: 'my_salon_setup',
          component: Setup
        },
        {
          path: 'salon_report_commission',
          component: ReportCommission
        },
        {
          name: 'salon_report_sales',
          path: 'salon_report_sales',
          component: ReportSales
          // component: ReportSales2
        },
        {
          name: 'salon_report_sales2',
          path: 'salon_report_sales2',
          component: ReportSales20221204
        },
        {
          path: 'salon_report_top_selling',
          component: TopSelling
        },
        {
          name: 'salon_report_payment',
          path: 'salon_report_payment',
          component: ReportPayment
        },
        {
          name: 'salon_report_payment2',
          path: 'salon_report_payment2',
          component: ReportPayment2
        },
        {
          name: 'salon_report_payment3',
          path: 'salon_report_payment3',
          component: ReportPayment3
        },
        {
          path: 'salon_report_order',
          component: ReportOrder
        },
        {
          path: 'salon_report_order2',
          component: ReportOrder2
        },
        {
          path: 'salon_report_order/salon_report_order',
          component: ReportOrder
        },
        {
          path: 'salon_report_delivery',
          component: ReportDelivery
        },
        {
          path: 'salon_report_order/salon_report_delivery',
          component: ReportDelivery
        },
        {
          path: 'salon_report_expenses',
          component: ReportExpenses
        },
        {
          path: 'salon_report_credit',
          component: ReportCredits
        },
        {
          path: 'salon_report_outstandings',
          component: ReportOutstandings
        },
        {
          path: 'salon_report_points',
          component: ReportPoints
        },
        {
          path: 'salon_report_voucher',
          component: ReportVoucher
        },
        {
          path: 'salon_report_attendance',
          component: ReportAttendance
        },
        {
          path: 'salon_report_reward',
          component: ReportReward
        },
        {
          path: 'salon_report_visit',
          component: ReportVisit
        },
        {
          path: 'salon_report_poke',
          component: ReportPoke
        },
        {
          path: 'salon_report_stock',
          component: Stock
        },
        {
          path: 'salon_report_stock2',
          component: Stock2
        },
        {
          path: 'salon_report_stock3',
          component: Stock3
        },
        {
          path: 'my_salon_broadcast',
          component: Broadcast
        },
        {
          path: 'salon_menu_reward',
          component: MenuReward
        },
        {
          path: 'salon_menu_service',
          component: MenuService
        },
        {
          path: 'salon_menu_service2',
          component: MenuService2
        },
        {
          path: 'salon_menu_service3',
          component: MenuService3
        },
        {
          path: 'salon_menu_product',
          component: MenuProduct
        },
        {
          path: 'salon_menu_product2',
          component: MenuProduct2
        },
        {
          path: 'salon_menu_product3',
          component: MenuProduct3
        },
        {
          path: 'salon_menu_package',
          component: MenuPackage
        },
        {
          path: 'salon_menu_package3',
          component: MenuPackage3
        },
        {
          path: 'salon_menu_discount',
          component: MenuDiscount
        },
        {
          path: 'salon_menu_discount3',
          component: MenuDiscount3
        },
        {
          path: 'salon_menu_treatment',
          component: MenuTreatment
        },
        {
          path: 'salon_menu_configuration',
          component: MenuConfiguration
        },
        {
          path: 'salon_setting_outlet',
          component: Outlet
        },
        {
          path: 'salon_setting_social',
          component: window.location.href.includes('devbusiness') ? SocialMedia : NoticeTunaiPro
        },
        {
          path: 'salon_setting_receipt',
          component: Receipt
        },
        {
          path: 'salon_setting_info',
          component: window.location.href.includes('devbusiness') ? Info : NoticeTunaiPro
        },
        {
          path: 'salon_setting_landing',
          component: Landing
        },
        {
          path: 'salon_setting_booking',
          component: window.location.href.includes('devbusiness') ? Booking : NoticeTunaiPro
        },
        {
          path: 'salon_setting_booking_block',
          component: window.location.href.includes('devbusiness') ? BookingBlockList : NoticeTunaiPro
        },
        {
          path: 'salon_setting_staff',
          component: Staff
        },
        {
          path: 'salon_setting_staff3',
          component: Staff3
        },
        {
          path: 'salon_setting_roster',
          name: 'salon_setting_roster',
          component: Roster
        },
        {
          path: 'salon_setting_security',
          component: SecuritySetting
        },
        {
          path: 'salon_setting_setup',
          component: OutletSetup
        },
        {
          path: 'salon_setting_washer',
          component: Washer
        },
        {
          path: 'salon_setting_token',
          component: CustomizeAppToken
        },
        {
          path: 'roster_staff_scheme',
          component: StaffScheme
        },
        {
          path: 'roster_leave_request',
          component: LeaveRequest
        },
        {
          path: 'roster_off_day',
          component: OffDay
        },
        {
          path: 'salon_wenawave_sales',
          component: WenawaveSales
        },
        {
          path: 'salon_wenawave_commission',
          component: WenawaveCommission
        },
        {
          path: 'salon_auraq7_sales',
          component: AuraQ7Sales
        },
        {
          path: 'salon_auraq7_commission',
          component: AuraQ7Commission
        },
        {
          path: 'salon_ariawellness_sales',
          component: AriaWellnessSales
        },
        {
          path: 'salon_ariawellness_commission',
          component: AriaWellnessCommission
        },
        {
          path: 'salon_lawawax_sales',
          component: LawaWaxSales
        },
        {
          path: 'salon_lawawax_commission',
          component: LawaWaxCommission
        },
        {
          path: 'salon_bianco_sales',
          component: BiancoByMeiNgSales
        },
        {
          path: 'salon_bianco_commission',
          component: BiancoByMeiNgCommission
        },
        {
          path: 'salon_regal_beaute_sales',
          component: RegalBeauteSales
        },
        {
          path: 'salon_regal_beaute_commission',
          component: RegalBeauteCommission
        },
        {
          path: 'salon_zenth_sales',
          component: ZenthSales
        },
        {
          path: 'salon_zenth_commission',
          component: ZenthCommission
        },
        {
          path: 'salon_estrella_sales',
          component: EstrellaSales
        },
        {
          path: 'salon_estrella_commission',
          component: EstrellaCommission
        },
        {
          path: 'salon_nimroc_sales',
          component: NimrocSales
        },
        {
          path: 'salon_nimroc_commission',
          component: NimrocCommission
        },
        {
          path: 'salon_seven_hair_studio_sales',
          component: SevenHairStudioSales
        },
        {
          path: 'salon_seven_hair_studio_commission',
          component: SevenHairStudioCommission
        },
        {
          path: 'salon_the_one_only_fitness_sales',
          component: TheOneOnlyFitnessSales
        },
        {
          path: 'salon_the_one_only_fitness_commission',
          component: TheOneOnlyFitnessCommission
        },
        {
          path: 'salon_oriya_sales',
          component: OriyaSales
        },
        {
          path: 'salon_oriya_commission',
          component: OriyaCommission
        },
        {
          path: 'salon_dasiawellness_sales',
          component: DAsiaWellnessSales
        },
        {
          path: 'salon_dasiawellness_commission',
          component: DAsiaWellnessCommission
        },
        {
          path: 'salon_JNSkin_sales',
          component: JNSkinSales
        },
        {
          path: 'salon_JNSkin_commission',
          component: JNSkinCommission
        },
        {
          path: 'salon_EnchantedSibling_sales',
          component: EnchantedSiblingSales
        },
        {
          path: 'salon_EnchantedSibling_commission',
          component: EnchantedSiblingCommission
        },
        {
          path: 'salon_VIISkin_sales',
          component: VIISkinSales
        },
        {
          path: 'salon_VIISkin_commission',
          component: VIISkinCommission
        },
        {
          path: 'salon_NailMiStudio_sales',
          component: NailMiStudioSales
        },
        {
          path: 'salon_NailMiStudio_commission',
          component: NailMiStudioCommission
        },
        {
          path: 'salon_CombAndCut_sales',
          component: CombAndCutSales
        },
        {
          path: 'salon_CombAndCut_commission',
          component: CombAndCutCommission
        },
        {
          path: 'salon_TheNailEdge_sales',
          component: TheNailEdgeSales
        },
        {
          path: 'salon_TheNailEdge_commission',
          component: TheNailEdgeCommission
        },
        {
          path: 'salon_TheNailEdge_commission_system',
          component: ReportCommission
        },
        {
          path: 'salon_OrientalSpa_sales',
          component: OrientalSpaSales
        },
        {
          path: 'salon_OrientalSpa_commission',
          component: OrientalSpaCommission
        },
        {
          path: 'salon_Unifit_sales',
          component: UnifitSales
        },
        {
          path: 'salon_Unifit_commission',
          component: UnifitCommission
        },
        {
          path: 'salon_PhiloHeadspa_sales',
          component: PhiloHeadspaSales
        },
        {
          path: 'salon_PhiloHeadspa_commission',
          component: PhiloHeadspaCommission
        },
        {
          path: 'salon_OrganicWay_sales',
          component: OrganicWaySales
        },
        {
          path: 'salon_OrganicWay_commission',
          component: OrganicWayCommission
        },
        {
          path: 'salon_PhiloHairStudio_sales',
          component: PhiloHairStudioSales
        },
        {
          path: 'salon_PhiloHairStudio_commission',
          component: PhiloHairStudioCommission
        },
      ]
    }
  ]
})